export default "__VITE_ASSET__C3ps7SwD__"